import {environment} from "../../../../../env.ts";

// noinspection RedundantConditionalExpressionJS
/**
 * The non grouped by view is generally faster, so by default we disable grouping
 *   TODO: We should set the default based on the data load
 */
export const CATEGORIZATION_DEFAULT_GROUP_BY = environment.isTestReviewPage ? false : false;

const TEST_SIZE = 10;

/**
 * The table has performance issues when page size is too big
 * Adjust this value to a lower number in case of performance issues
 */
const DEFAULT_PAGE_SIZE = 25;
const DEFAULT_PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 50, 100, 500] as number[];

export const CATEGORIZATION_TABLE_DEFAULT_PAGE_SIZE = environment.isTestReviewPage ? TEST_SIZE : DEFAULT_PAGE_SIZE;
export const CATEGORIZATION_TABLE_PAGE_OPTIONS = environment.isTestReviewPage ? [TEST_SIZE, ...DEFAULT_PAGE_SIZE_OPTIONS] : DEFAULT_PAGE_SIZE_OPTIONS;
